import BillingPage from "@/pages/BillingPage";
import UltimateAdmin from "@/pages/UltimateAdmin";
import BetaReferralProgram from "@/pages/BetaReferralProgram";
import { analytics } from '@/lib/firebase';
import { logEvent } from 'firebase/analytics';
import { installations } from '@/lib/firebase';
import { getId } from 'firebase/installations';
import { functionsAsia } from '@/lib/firebase';
import { httpsCallable } from 'firebase/functions';
import MyReports from "@/pages/MyReports";
import GstReports from "@/pages/GstReports";
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Checkout } from 'capacitor-razorpay';
import { doc, setDoc, onSnapshot } from 'firebase/firestore'; // 👈 Added onSnapshot
import { db } from '@/lib/firebase';
import { StatusBar, Style } from '@capacitor/status-bar';
import ReferralTracking from "@/pages/ReferralTracking";
import PrinterSettings from "@/pages/PrinterSettings";
import InvoiceSettings from "@/pages/InvoiceSettings";
import ReferAndEarn from "@/pages/ReferAndEarn";
import { autoConnectBTPrinter } from "@/lib/btPrinter";
import { Switch, Route, Redirect, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useAuth } from "@/hooks/use-auth";
import { useDeviceRegister } from "@/hooks/use-device-register";
import { DataProvider, useData } from "@/contexts/DataContext";
import { BottomNav } from "@/components/BottomNav";
import { SaathiFab } from "@/components/SaathiFab";
import { AdSlot } from "@/components/AdSlot";
import { useShowAds } from "@/hooks/useShowAds";
import { BANNER_ENABLED } from "@/lib/ads";
import { CountUpSplash } from "@/components/CountUpSplash";
import { useEffect, useRef, useState } from "react";
import SubscriptionPage from "@/pages/SubscriptionPage";
import PaymentStatusPage from "@/pages/PaymentStatusPage";
import { useToast } from "@/hooks/use-toast";
import {
  LogOut,
  Crown,
  Zap,
  ArrowRight,
  RefreshCw,
  Trash2,
  WifiOff,
  Loader2,
  ChevronLeft,
  AlertTriangle, // 👈 Added for Maintenance
  Megaphone,     // 👈 Added for Notice
  X             // 👈 Added for Notice
} from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

import { PWALoader } from "@/components/PWALoader";
import { ProUpgradeModal } from "@/components/ProUpgradeModal";
import { InstallDesktopGate } from "@/components/InstallDesktopGate";
import { TierChangeModal } from "@/components/TierChangeModal";
import { ProfileCompletionBanner } from "@/components/ProfileCompletionBanner";

import Landing from "@/pages/Landing";
import AndroidLandingPage from "@/pages/AndroidLandingPage";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Transactions from "@/pages/Transactions";
import Settings from "@/pages/Settings";
import SetupSheet from "@/pages/SetupSheet";
import BusinessSetup from "@/pages/BusinessSetup";
import BusinessSetupV2 from "@/pages/BusinessSetupV2";
import NotFound from "@/pages/not-found";
import Downloads from "@/pages/Downloads";
import ProfilePage from "@/pages/ProfilePage";

// Normal* pages removed — single unified UI (Dashboard/Products/Transactions/Settings).
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import ShippingAndRefunds from "@/pages/ShippingAndRefunds";
import UserDocs from "@/pages/UserDocs";
import BetaTesterPromo from "@/pages/BetaTesterPromo";
import RequestCallback from "@/pages/RequestCallback";
import DataDeletion from "@/pages/DataDeletion";
import UserGuide from "@/pages/UserGuide";
import SupportedPrinters from "@/pages/SupportedPrinters";
import Rewards from "@/pages/Rewards";
import Support from "@/pages/Support";
import PublicInvoice from "@/pages/PublicInvoice";
import InviteLanding from "@/pages/InviteLanding";
import MarketingLanding from "@/pages/MarketingLanding";
import Alerts from "@/pages/Alerts";
import Blogs from "@/pages/Blogs";
import BlogPost from "@/pages/BlogPost";
import BlogAdmin from "@/pages/BlogAdmin";
import Documentation from "@/pages/Documentation";
import DocPage from "@/pages/DocPage";
import DocAdmin from "@/pages/DocAdmin";
import { lazy, Suspense } from "react";
const UltimateDashboard = lazy(() => import("@/pages/ultimate/UltimateDashboard"));
const UltimateTransactions = lazy(() => import("@/pages/ultimate/UltimateTransactions"));
const UltimateProducts = lazy(() => import("@/pages/ultimate/UltimateProducts"));
const UltimateSettings = lazy(() => import("@/pages/ultimate/UltimateSettings"));
const UltimateStaffActivity = lazy(() => import("@/pages/ultimate/UltimateStaffActivity"));
const UltimateDesktopAccess = lazy(() => import("@/pages/ultimate/UltimateDesktopAccess"));
const UltimateAiKey = lazy(() => import("@/pages/ultimate/UltimateAiKey"));
import {
  UltimateDashboardSkeleton,
  UltimateTransactionsSkeleton,
  UltimateProductsSkeleton,
  UltimateSettingsSkeleton,
  UltimateGenericSkeleton,
} from "@/components/ultimate/UltimateSkeleton";

// ── 🚨 NEW: MAINTENANCE SCREEN ──
function MaintenanceOverlay({ message }: { message?: string }) {
  return (
    <div className="fixed inset-0 z-[10000] bg-white dark:bg-slate-950 flex flex-col items-center justify-center p-6 text-center">
      <div className="w-full max-w-sm flex flex-col items-center gap-6 animate-in fade-in zoom-in duration-300">
        <div className="bg-amber-100 dark:bg-amber-900/30 rounded-3xl p-6 shadow-xl shadow-amber-500/10">
          <AlertTriangle className="h-16 w-16 text-amber-600" />
        </div>
        <Logo size="lg" />
        <div className="space-y-3 px-4">
          <h2 className="text-2xl font-black text-slate-900 dark:text-white uppercase tracking-tight">Under Maintenance</h2>
          <p className="text-sm text-slate-500 dark:text-slate-400 font-bold leading-relaxed">
            {message || "We are currently performing scheduled system upgrades. DailyHisaab will be back online shortly."}
          </p>
        </div>
        <div className="w-full h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
          <div className="h-full bg-amber-500 w-1/2 animate-maintenance-progress" />
        </div>
        <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Thank you for your patience</p>
      </div>
    </div>
  );
}

// ── 📢 POPUP STYLE: GLOBAL NOTICE MODAL ──
function GlobalNotice({ message }: { message: string }) {
  const [isVisible, setIsVisible] = useState(true);

  // 🛡️ Logic to prevent the popup from reappearing every time the user 
  // navigates during a single session if they've already dismissed it.
  useEffect(() => {
    const isDismissed = sessionStorage.getItem("notice_dismissed");
    if (isDismissed === message) {
      setIsVisible(false);
    }
  }, [message]);

  const handleDismiss = () => {
    sessionStorage.setItem("notice_dismissed", message);
    setIsVisible(false);
  };

  if (!isVisible || !message) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="w-full max-w-sm bg-white dark:bg-slate-900 rounded-[32px] shadow-2xl overflow-hidden animate-in zoom-in duration-300 border border-slate-200 dark:border-slate-800">
        {/* Modal Header/Icon */}
        <div className="bg-[#8B1A1A] p-8 flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4 backdrop-blur-md">
            <Megaphone className="w-8 h-8 text-white" />
          </div>
          <h3 className="text-xl font-black text-white tracking-tight">System Announcement</h3>
        </div>

        {/* Modal Content */}
        <div className="p-8 text-center">
          <p className="text-slate-600 dark:text-slate-300 font-bold leading-relaxed">
            {message}
          </p>
        </div>

        {/* Action Button */}
        <div className="p-6 pt-0">
          <button
            onClick={handleDismiss}
            className="w-full py-4 bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-black rounded-2xl shadow-xl active:scale-95 transition-all text-sm uppercase tracking-widest"
          >
            Acknowledge
          </button>
        </div>
      </div>
    </div>
  );
}

function OfflineIndicator() {
  const { isOnline } = useData();
  if (isOnline) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] flex justify-center pointer-events-none pt-safe-or-2 pt-2 transition-all duration-300">
      <div className="bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg shadow-red-500/30 flex items-center gap-1.5 animate-in slide-in-from-top-4 fade-in">
        <WifiOff className="h-3.5 w-3.5" />
        Offline
      </div>
    </div>
  );
}

function DeletionPendingPopup() {
  const {
    deletionRequestedAt,
    deletionReason,
    revokeAccountDeletion,
    businessProfile,
  } = useData();
  const { logout, user } = useAuth();
  const [isRevoking, setIsRevoking] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => () => { mountedRef.current = false; }, []);

  const requestedDate = deletionRequestedAt
    ? new Date(deletionRequestedAt).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    : "";

  return (
    <div className="fixed inset-0 z-[200] bg-gradient-to-b from-red-50 via-white to-red-50 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm flex flex-col items-center gap-6">
        <div className="bg-red-100 dark:bg-red-900/30 rounded-full p-4">
          <Trash2 className="h-12 w-12 text-[#8B2121] dark:text-red-400" />
        </div>
        <Logo size="lg" />
        <div className="text-center space-y-2">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">Account Deletion Pending</h2>
          <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
            Your account is scheduled for deletion within 30 days. You can cancel this at any time.
          </p>
        </div>
        {requestedDate && (
          <div className="flex items-center gap-1.5 bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-800 rounded-2xl px-4 py-2">
            <span className="text-sm text-red-700 dark:text-red-400">Requested on {requestedDate}</span>
          </div>
        )}
        <div className="w-full space-y-3 mt-2">
          <button
            onClick={async () => {
              setIsRevoking(true);
              try {
                await revokeAccountDeletion();
                try {
                  const name = businessProfile?.businessName || "Valued Customer";
                  const email = businessProfile?.businessEmail || user?.email || "";
                  const sendRevocation = httpsCallable(functionsAsia, 'triggerRevocationEmail');
                  await sendRevocation({ name, email, reason: deletionReason });
                } catch (emailErr) { console.warn("Revocation email failed", emailErr); }
              } catch (err) { console.error("Error revoking deletion:", err); }
              finally { if (mountedRef.current) setIsRevoking(false); }
            }}
            disabled={isRevoking}
            className="w-full flex items-center justify-center gap-2 text-white font-bold rounded-2xl py-4 px-6 text-base transition-all active:scale-[0.98] shadow-lg disabled:opacity-60"
            style={{ background: "linear-gradient(135deg, #8B1A1A 0%, #631212 100%)" }}
          >
            {isRevoking ? <RefreshCw className="h-5 w-5 animate-spin" /> : <><ArrowRight className="h-5 w-5" /> Revoke Cancellation</>}
          </button>
          <button onClick={() => logout()} className="w-full flex items-center justify-center gap-2 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 font-semibold rounded-2xl py-4 px-6 text-base transition-all active:scale-[0.98] border border-slate-200 dark:border-slate-700">
            <LogOut className="h-5 w-5" /> Log Out
          </button>
        </div>
      </div>
    </div>
  );
}

function ProExpiredPopup() {
  const { dismissProExpiry, rewardPoints, openProUpgradeModal, businessProfile, proModeExpiry } = useData();

  // 🛡️ STRICT ELIGIBILITY: If proModeExpiry exists at all (past/present/future), trial is disabled
  const isEligibleForTrial = !proModeExpiry && !businessProfile?.hasUsedProTrial;

  return (
    <div className="fixed inset-0 z-[200] bg-gradient-to-b from-amber-50 via-white to-amber-50 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 flex flex-col items-center justify-center p-6">
      <div className="w-full max-sm flex flex-col items-center gap-6 text-center">
        <div className="bg-amber-100 dark:bg-amber-900/30 rounded-full p-4">
          <Crown className="h-12 w-12 text-amber-500" />
        </div>
        <Logo size="lg" />
        <div className="text-center space-y-2 px-4">
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">Your Premium Plan Expired</h2>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Your Premium subscription has ended. Renew to stay ad-free, or continue with ads.
          </p>
        </div>
        <div className="flex items-center gap-1.5 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-2xl px-4 py-2">
          <Zap className="h-4 w-4 text-amber-500 fill-amber-500" />
          <span className="text-sm font-bold text-amber-700 dark:text-amber-400">{rewardPoints.toLocaleString()} Reward Points</span>
        </div>
        <div className="w-full space-y-3 mt-2">
          <button
            onClick={openProUpgradeModal}
            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-bold rounded-2xl py-4 px-6 text-base transition-all active:scale-[0.98] shadow-lg shadow-amber-500/20"
          >
            <Crown className="h-5 w-5" />
            {/* 🛡️ DYNAMIC BUTTON TEXT based on EVER-active Pro status */}
            {isEligibleForTrial ? "Start 7-Day Free Trial" : "Go Premium Again"}
            <ArrowRight className="h-4 w-4 ml-1" />
          </button>
          <button onClick={() => dismissProExpiry(true)} className="w-full flex items-center justify-center gap-2 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold rounded-2xl py-4 px-6 text-base transition-all active:scale-[0.98] border border-slate-200 dark:border-slate-700">
            Continue with Ads
          </button>
        </div>
      </div>
    </div>
  );
}

function AuthenticatedApp({ systemStatus }: { systemStatus: any }) { // 👈 Accepts systemStatus
  const {
    isLoading,
    dataInitialized,
    isPaid,
    isUltimateOwnerMobile,
    proModeExpiry,
    profileCompleted,
    businessProfile,
    proExpired,
    deletionRequestedAt,
  } = useData();

  // Register device + heartbeat for Ultimate plan enforcement
  useDeviceRegister();

  // Show the AdMob bottom banner only for non-subscribers on native (web = no ads).
  const showAds = useShowAds();

  // Force dark theme on Ultimate mobile unless user has explicitly toggled.
  useEffect(() => {
    if (!isUltimateOwnerMobile) return;
    const override = localStorage.getItem("theme_user_override") === "true";
    if (override) return;
    document.documentElement.classList.add("dark");
    localStorage.setItem("theme", "dark");
  }, [isUltimateOwnerMobile]);

  // Tag <html data-ultimate-mode> whenever dark mode is active (any tier) so
  // the Ultimate dark-color overlay in index.css repaints body/headers/cards
  // for Basic & Pro too. Stays off in light mode so Basic/Pro light surfaces
  // are not changed.
  useEffect(() => {
    const root = document.documentElement;
    const sync = () => {
      const isDark = root.classList.contains("dark");
      if (isDark) {
        root.setAttribute("data-ultimate-mode", "");
      } else {
        root.removeAttribute("data-ultimate-mode");
      }
    };
    sync();
    const obs = new MutationObserver(sync);
    obs.observe(root, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);

  // Ultimate-only typography (uppercase h1 etc.) gated behind a separate
  // attribute so Basic/Pro don't inherit it from data-ultimate-mode.
  useEffect(() => {
    if (isUltimateOwnerMobile) {
      document.documentElement.setAttribute("data-ultimate-typography", "");
    } else {
      document.documentElement.removeAttribute("data-ultimate-typography");
    }
  }, [isUltimateOwnerMobile]);

  // Hold the loader high during the gap between settings-load and data-load
  // so the dashboard doesn't briefly flash empty between the two phases on
  // first sign-in / post-onboarding reload.
  const showLoader = isLoading || (profileCompleted && !dataInitialized);
  // On native, once the count-up launch splash has finished, never fall back to
  // the old "Loading your data" screen — render the dashboard (cached data) instead.
  const splashCoveredLoad = Capacitor.isNativePlatform() && launchSplashShown;

  if (showLoader && !splashCoveredLoad) {
    if (isUltimateOwnerMobile) {
      const path = typeof window !== "undefined" ? window.location.hash.replace(/^#/, "") : "/";
      if (path === "/transactions") return <UltimateTransactionsSkeleton />;
      if (path === "/products" || path === "/inventory") return <UltimateProductsSkeleton />;
      if (path === "/settings") return <UltimateSettingsSkeleton />;
      if (path === "/staff-activity" || path === "/desktop-access" || path === "/ai-key") return <UltimateGenericSkeleton />;
      return <UltimateDashboardSkeleton />;
    }
    return <PWALoader message="Loading your data..." />;
  }

  if (!profileCompleted) {
    const useClassic = systemStatus?.onboardingClassic === true;
    const SetupComponent = useClassic ? BusinessSetup : BusinessSetupV2;
    return <SetupComponent onComplete={() => { window.location.reload(); }} initialData={businessProfile || undefined} />;
  }

  if (deletionRequestedAt) return <DeletionPendingPopup />;

  // No blocking "plan expired" popup — an expired subscription seamlessly becomes
  // free-with-ads. Renewal is surfaced non-intrusively via the Settings "Go Premium" card.

  return (
    <div className="min-h-screen bg-background">
      <OfflineIndicator />
      <ProfileCompletionBanner />

      {/* 📢 NEW: Global Notice Banner rendered here */}
      {systemStatus.globalNotice && <GlobalNotice message={systemStatus.globalNotice} />}

      {isUltimateOwnerMobile && <InstallDesktopGate>{null}</InstallDesktopGate>}
      <TierChangeModal />

      <main className={showAds && BANNER_ENABLED ? "pb-[calc(4rem+60px+env(safe-area-inset-bottom))]" : "pb-[calc(4rem+env(safe-area-inset-bottom))]"}>
        <Switch>
          <Route path="/subscribe" component={SubscriptionPage} />
          <Route path="/payment-status" component={PaymentStatusPage} />
          <Route path="/alerts" component={Alerts} />

          {/* 🚨 Globally accessible Profile */}
          <Route path="/profile" component={ProfilePage} />

          {isUltimateOwnerMobile ? (
            <>
              <Route path="/">
                {() => (
                  <Suspense fallback={<UltimateDashboardSkeleton />}>
                    <UltimateDashboard />
                  </Suspense>
                )}
              </Route>
              <Route path="/dashboard">
                {() => (
                  <Suspense fallback={<UltimateDashboardSkeleton />}>
                    <UltimateDashboard />
                  </Suspense>
                )}
              </Route>
              <Route path="/transactions">
                {() => (
                  <Suspense fallback={<UltimateTransactionsSkeleton />}>
                    <UltimateTransactions />
                  </Suspense>
                )}
              </Route>
              <Route path="/products">
                {() => (
                  <Suspense fallback={<UltimateProductsSkeleton />}>
                    <UltimateProducts />
                  </Suspense>
                )}
              </Route>
              <Route path="/inventory">
                {() => (
                  <Suspense fallback={<UltimateProductsSkeleton />}>
                    <UltimateProducts />
                  </Suspense>
                )}
              </Route>
              <Route path="/settings">
                {() => (
                  <Suspense fallback={<UltimateSettingsSkeleton />}>
                    <UltimateSettings />
                  </Suspense>
                )}
              </Route>
              <Route path="/staff-activity">
                {() => (
                  <Suspense fallback={<UltimateGenericSkeleton />}>
                    <UltimateStaffActivity />
                  </Suspense>
                )}
              </Route>
              <Route path="/desktop-access">
                {() => (
                  <Suspense fallback={<UltimateGenericSkeleton />}>
                    <UltimateDesktopAccess />
                  </Suspense>
                )}
              </Route>
              <Route path="/ai-key">
                {() => (
                  <Suspense fallback={<UltimateGenericSkeleton />}>
                    <UltimateAiKey />
                  </Suspense>
                )}
              </Route>
            </>
          ) : (
            // Normal mode removed — one unified UI for everyone. Stale Normal deep
            // links (/home, /inventory) redirect to their Pro-page equivalents.
            <>
              <Route path="/" component={Dashboard} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/home"><Redirect to="/dashboard" /></Route>
              <Route path="/products" component={Products} />
              <Route path="/inventory"><Redirect to="/products" /></Route>
              <Route path="/transactions" component={Transactions} />
              <Route path="/settings" component={Settings} />
            </>
          )}
          <Route path="/guide" component={UserGuide} />
          <Route path="/supported-printers" component={SupportedPrinters} />
          <Route path="/printer-settings" component={PrinterSettings} />
          <Route path="/invoice-settings" component={InvoiceSettings} />
          <Route path="/refer" component={ReferAndEarn} />
          <Route path="/referrals" component={ReferralTracking} />
          <Route path="/rewards" component={Rewards} />
          <Route path="/support" component={Support} />
          <Route path="/privacy" component={PrivacyPolicy} />
          <Route path="/docs" component={UserDocs} />
          <Route path="/terms" component={TermsOfService} />
          <Route path="/shipping-refunds" component={ShippingAndRefunds} />
          <Route path="/data-deletion" component={DataDeletion} />
          <Route path="/my-reports" component={MyReports} />
          <Route path="/gst-reports" component={GstReports} />
          <Route path="/billing" component={BillingPage} />
          <Route path="/ultimate-admin">
            {() => isUltimateOwnerMobile ? <Redirect to="/settings" /> : <UltimateAdmin />}
          </Route>

          {/* 📝 New Routes for Blogs/Docs */}
          <Route path="/blogs" component={Blogs} />
          <Route path="/blog/:id" component={BlogPost} />
          <Route path="/admin/blogs" component={BlogAdmin} />
          <Route path="/documentation" component={Documentation} />
          <Route path="/doc/:id" component={DocPage} />
          <Route path="/admin/docs" component={DocAdmin} />

          <Route component={NotFound} />
        </Switch>
      </main>
      <BottomNav />
      {showAds && <AdSlot />}
      {/* Saathi AI always visible; free-user tap offers a Premium upgrade. */}
      <SaathiFab />
    </div>
  );
}

// Count-up launch splash shows once per cold start (module flag survives remounts).
let launchSplashShown = false;

// Holds the splash until the real screen (dashboard/onboarding/landing) is ready
// to render with NO loader, so neither old PWALoader ever flashes after it.
function LaunchSplashGate({ onDone, appBusy }: { onDone: () => void; appBusy: boolean }) {
  const { isLoading, dataInitialized, profileCompleted } = useData();
  const { user } = useAuth();
  const authAppLoading = isLoading || (profileCompleted && !dataInitialized);
  const appReady = !appBusy && (!user || !authAppLoading);
  return <CountUpSplash onDone={onDone} appReady={appReady} />;
}

function AppRouter() {
  const { user, isLoading: authLoading } = useAuth();
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);
  const [splashDone, setSplashDone] = useState(() => launchSplashShown);
  const { toast } = useToast();

  // ── 🛡️ NEW: REAL-TIME SYSTEM LISTENER ──
  const [systemStatus, setSystemStatus] = useState({
    maintenanceMode: false,
    globalNotice: "",
    maintenanceMessage: "",
    onboardingClassic: false
  });

  useEffect(() => {
    // 🔔 Listen to app_status for Maintenance/Notice
    const unsub = onSnapshot(doc(db, "system_config", "app_status"), (snap) => {
      if (snap.exists()) {
        setSystemStatus(snap.data() as any);
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (user && Capacitor.isNativePlatform()) {
      const setupPushNotifications = async () => {
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive === 'prompt') permStatus = await PushNotifications.requestPermissions();
        if (permStatus.receive !== 'granted') return;

        await PushNotifications.removeAllListeners();
        await PushNotifications.register();

        PushNotifications.addListener('registration', async (token) => {
          try {
            const tokenRef = doc(db, 'users', user.uid, 'fcm_tokens', token.value);
            await setDoc(tokenRef, {
              token: token.value,
              device: Capacitor.getPlatform(),
              updatedAt: new Date().toISOString()
            });
          } catch (error) { console.error("Error saving token:", error); }
        });

        PushNotifications.addListener('pushNotificationReceived', (notification) => {
          toast({ title: notification.title || "New Notification", description: notification.body || "", duration: 10000 });
        });
      };
      setupPushNotifications();
    }
  }, [user, toast]);

  const [isPWA] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone ||
      document.referrer.includes("android-app://") ||
      (window as any).Capacitor?.getPlatform() === 'android';
  });

  useEffect(() => {
    const setupStatusBar = async () => {
      if (!Capacitor.isNativePlatform()) return;
      try {
        await StatusBar.setOverlaysWebView({ overlay: true });
        const isDark = document.documentElement.classList.contains("dark");
        await StatusBar.setBackgroundColor({ color: isDark ? "#1A1614" : "#FFFBF2" });
        await StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light });
      } catch (err) {
        console.warn("Status bar setup failed:", err);
      }
    };
    setupStatusBar();
    // Re-apply on theme change.
    const observer = new MutationObserver(setupStatusBar);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  useEffect(() => { if (user?.uid) autoConnectBTPrinter(user.uid); }, [user?.uid]);

  useEffect(() => {
    if (isPWA) {
      const timer = setTimeout(() => { setMinTimeElapsed(true); }, 2500);
      return () => clearTimeout(timer);
    } else setMinTimeElapsed(true);
  }, [isPWA]);

  const showGlobalLoader = authLoading || (isPWA && !minTimeElapsed);

  // 🛡️ EMERGENCY BLOCK: Maintenance Mode takes priority
  if (systemStatus.maintenanceMode) {
    return <MaintenanceOverlay message={systemStatus.maintenanceMessage} />;
  }

  return (
    <DataProvider>
      <ProUpgradeModal />
      {isPWA && !splashDone && (
        <LaunchSplashGate appBusy={showGlobalLoader} onDone={() => { launchSplashShown = true; setSplashDone(true); }} />
      )}
      {showGlobalLoader && !(isPWA && !splashDone) ? (
        <PWALoader message="Initializing app..." />
      ) : (
        <Switch>
          <Route path="/app/invite" component={InviteLanding} />
          <Route path="/m/:slug" component={MarketingLanding} />
          <Route path="/in">{Capacitor.isNativePlatform() ? <AndroidLandingPage /> : <Landing />}</Route>
          <Route path="/privacy" component={PrivacyPolicy} />
          <Route path="/docs" component={UserDocs} />
          <Route path="/terms" component={TermsOfService} />
          <Route path="/data-deletion" component={DataDeletion} />
          <Route path="/shipping-refunds" component={ShippingAndRefunds} />
          <Route path="/downloads" component={Downloads} />
          <Route path="/beta" component={BetaTesterPromo} />
          <Route path="/callback" component={RequestCallback} />
          {!user && <Route path="/support" component={Support} />}
          <Route path="/beta-referral" component={BetaReferralProgram} />
          <Route>
            {!user ? (
              Capacitor.isNativePlatform() ? <AndroidLandingPage /> : <Landing />
            ) : (
              <AuthenticatedApp systemStatus={systemStatus} />
            )}
          </Route>
        </Switch>
      )}
    </DataProvider>
  );
}

export default function App() {
  const currentPath = window.location.pathname;

  if (currentPath.startsWith("/invoice/")) {
    const parts = currentPath.split("/");
    if (parts.length === 4) {
      return (
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <Toaster />
            <Route path="/invoice/:userId/:orderId" component={PublicInvoice} />
          </TooltipProvider>
        </QueryClientProvider>
      );
    }
  }

  if (currentPath.startsWith("/bill/")) {
    const parts = currentPath.split("/");
    if (parts.length === 3) {
      return (
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <Toaster />
            <Route path="/bill/:shortId" component={PublicInvoice} />
          </TooltipProvider>
        </QueryClientProvider>
      );
    }
  }

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <ToastContainer position="top-right" autoClose={3000} />
        <AppRouter />
      </TooltipProvider>
    </QueryClientProvider>
  );
}